import React, { useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import Box from '../../../Global/Box'
import ContentHeader from '../../../Layout/ContentHeader'
import { useMutation, useQuery } from '@apollo/client'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import {
  CREATE_ROLE,
  GET_ROLES,
  GET_ROLE_BY_ID,
  UPDATE_ROLE,
} from '../../../../graphql/Catalog/Roles/roles'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useHistory, useParams } from 'react-router-dom'
import InputController from '../../../Global/InputController'
import { AuthContext } from '../../../../Auth/AuthContext'

export const RolesNew = () => {
  const { id: _id, show } = useParams()
  const { user } = useContext(AuthContext)
  const { showLoading, hideLoading } = useLoading()

  const [createRole] = useMutation(CREATE_ROLE, {
    refetchQueries: [
      {
        query: GET_ROLES,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const [updateRole] = useMutation(UPDATE_ROLE, {
    refetchQueries: [
      {
        query: GET_ROLES,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      { query: GET_ROLE_BY_ID, variables: { getOneRoleId: parseInt(_id) } },
    ],
  })

  const {
    data: dataRoleId,
    loading: loadingRoleId,
    error: errorRoleId,
  } = useQuery(GET_ROLE_BY_ID, {
    variables: {
      getOneRoleId: parseInt(_id),
    },
  })

  const [loadingBtn, setLoadingBtn] = useState(false)
  const history = useHistory()

  const validationSchema = Yup.object().shape({
    role_name: Yup.string().required('Campo requerido'),
    description: Yup.string(),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  useEffect(() => {
    if (!loadingRoleId) {
      if (_id) {
        if (errorRoleId) {
          setLoadingBtn(false)
          return toastSweetAlert({
            mode: 'error',
            message: errorRoleId.message,
          })
        }

        reset(dataRoleId?.getOneRole)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataRoleId, errorRoleId])

  const onSubmit = async (Data) => {
    setLoadingBtn(true)
    showLoading()
    try {
      if (_id) {
        await updateRole({
          variables: {
            roleId: parseInt(_id),
            input: {
              role_name: Data.role_name,
              description: Data.description,
              id_user_update: user.idUser,
            },
          },
        })
        return (
          toastSweetAlert({
            mode: 'ok',
            message: 'Rol ha sido actualizado correctamente',
          }),
          history.push(`/catalog/roles`)
        )
      } else {
        await createRole({
          variables: {
            input: {
              role_name: Data.role_name,
              description: Data.description,
              id_user_register: user.idUser,
            },
          },
        })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Rol ha sido creado correctamente',
          },
          history.push(`/catalog/roles`)
        )
      }
    } catch (error) {
      setLoadingBtn(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }
  return (
    <>
      <ContentHeader
        title="Roles de usuario"
        breadcrumb="Roles"
        windowTitle={`${_id ? 'Editar' : 'Agregar'} rol `}
      />
      <FormProvider {...methods}>
        <form className="p-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? (show ? 'Detalles': 'Editar') : 'Agregar nuevo'} rol`}
            btnRedPath="/catalog/roles"
            btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={!show}
            btnLoading={loadingBtn}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-lg-12 col-md-12 col-sm-12">
                    <InputController
                      disabled={show}
                      label="Nombre del rol"
                      name="role_name"
                      type="text"
                      placeholder="Nombre del rol"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-lg-12 col-md-12 col-sm-12">
                    <InputController
                      disabled={show}
                      label="Descripción"
                      name="description"
                      inputType="textarea"
                      rows={3}
                      placeholder="Descripción"
                      control={control}
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}
export default RolesNew
